// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ModelSettingsConfig, ModelType } from '../models/model-settings.interface';

export const environment = {
  production: false,
  platform: 'web', // 'web' or 'mobile'
  appName: 'WinDoc Dev',
  isSuperAdmin: true,

  // Default Model Settings
  defaultModelSettings: {
    primaryModel: 'GLM_45V' as ModelType,
    modelOrder: ['GLM_45V', 'GROQ_SCOUT', 'QWEN2P5_VL_32B_INSTRUCT', 'GROQ_MAVERICK', 'HUGGINGFACE_GLM_45V', 'FIREWORKS_GLM_45V', 'GPT_4O'] as ModelType[],
    useTraditionalPipelineOnly: false, // Allow AI models by default
    models: {
      'GPT_4O': {
        enabled: false,
        name: 'GPT-4o',
        isDeprecated: true, // API no longer supported
        settings: {
          processingMode: 'json' as const, // 'json' | 'image'
          optimizeImageSize: true,
          useImageUrl: false
        }
      },
      'GLM_45V': {
        enabled: true,
        name: 'GLM-4.5V',
        settings: {
          thinkingMode: false,
          optimizeImageSize: true,
          useImageUrl: false,
          apiTimeout: 300,
          glmModelVersion: 'glm-4.5v' as const
        }
      },
      'HUGGINGFACE_GLM_45V': {
        enabled: false,
        name: 'HuggingFace GLM-4.5V',
        isDeprecated: true, // API no longer supported
        settings: {
          thinkingMode: false,
          optimizeImageSize: false,
          useImageUrl: false,
          apiTimeout: 300
        }
      },
      'GROQ_SCOUT': {
        enabled: true,
        name: 'Groq Llama 4 Scout',
        settings: {
          optimizeImageSize: true,
          useImageUrl: false,
          apiTimeout: 300
        }
      },
      'GROQ_MAVERICK': {
        enabled: false,
        name: 'Groq Llama 4 Maverick',
        isDeprecated: true, // API no longer supported
        settings: {
          optimizeImageSize: true,
          useImageUrl: false,
          apiTimeout: 300
        }
      },
      'FIREWORKS_GLM_45V': {
        enabled: false,
        name: 'Fireworks GLM-4.5V',
        isDeprecated: true, // API no longer supported
        settings: {
          thinkingMode: false,
          optimizeImageSize: true,
          useImageUrl: false,
          apiTimeout: 300
        }
      },
      'QWEN2P5_VL_32B_INSTRUCT': {
        enabled: true,
        name: 'Qwen3-VL-32B-Instruct',
        settings: {
          thinkingMode: false,
          optimizeImageSize: true,
          useImageUrl: false,
          apiTimeout: 300
        }
      }
    }
  } as ModelSettingsConfig,

  // webSocketUrl: 'ws://192.168.101.176:8085/ws',
  // apiUrl: 'http://192.168.101.176:8085',  // Adjust to your FastAPI local URL
  // webSockeRealTimetUrl: 'ws://192.168.101.176:8085/websocket/realtime_processing',

  // webSocketUrl: 'ws://192.168.101.176:8088/ws',
  // apiUrl: 'http://192.168.101.176:8088',  // Adjust to your FastAPI local URL
  // webSockeRealTimetUrl: 'ws://192.168.101.176:8088/websocket/realtime_processing'

  // Feature toggle: when true the app will skip the welcome page and open the WinDoc Direct login
  ENABLE_LOGIN_WINDOCDIRECT: true,
  FEATURE_ENABLE_PAID_PLANS: false,

  // SPR OCR Profile Mode: When enabled, only SPR OCR AI services are shown
  // and outputs are in JSON format instead of Excel
  isSprOcrEnv: true,

  webSocketUrl: 'wss://winproduit.sophatel.com:8001/ws',
  apiUrl: 'https://winproduit.sophatel.com:8001',  // Adjust to your FastAPI local URL
  webSockeRealTimetUrl: 'wss://winproduit.sophatel.com:8001/websocket/realtime_processing'

  // webSocketUrl: 'wss://windoc-api.sophatel.com/ws',
  // apiUrl: 'https://windoc-api.sophatel.com',  // Adjust to your FastAPI local URL
  // webSockeRealTimetUrl: 'wss://windoc-api.sophatel.com/websocket/realtime_processing'

  // webSocketUrl: 'wss://winproduit.sophatel.com:8000/ws',
  // apiUrl: 'https://winproduit.sophatel.com:8000',  // Adjust to your FastAPI local URL
  // webSockeRealTimetUrl: 'wss://winproduit.sophatel.com:8000/websocket/realtime_processing'


  // webSocketUrl: 'wss://ocr-api.abdohero.com/ws', // Secure WebSocket URL
  // apiUrl: 'https://ocr-api.abdohero.com',  // Adjust to your FastAPI server URL
  // webSockeRealTimetUrl: 'wss://ocr-api.abdohero.com/websocket/realtime_processing'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.